import {PB_HEADERS} from '../constants';

export const getFileHeaders = (crmType: string) => ({
    userId: 'User Id',
    userEmail: 'User Email',
    oldValue: `Old ${PB_HEADERS[crmType]}`,
    newValue: `New ${PB_HEADERS[crmType]}`,
    actionStatus: 'Action Status',
});
